import React from 'react'
import styles from '../Messages.module.css'

const InputResponse = props => {
  const letter = props.currentLetter.toUpperCase()
  let message = ''

  
  if (props.remainingGuesses === props.numberOfGuesses) {
    message = 'Guess the 3 word phrase'
  }
  
  if (props.correctLettersCount === 0) {
    message = `There are no "${letter}"'s`
  } 
  
  if (props.correctLettersCount >= 1) {
    message = `There ${props.correctLettersCount === 1 ? 'is' : 'are'} ${props.correctLettersCount} "${letter}"${props.correctLettersCount === 1 ? '' : 's'}`
  }

  if(props.gameStatus === 'finished' || props.gameStatus === 'failed') {
    message = null
  }

  
  return (
    <div className={styles.InputResponse}>
      {message}
    </div>
  )
}

export default InputResponse
